<template>
    <div class="section full-white-border">
        <div class="bet-slip-item-container">
            <v-container fluid px-0 py-0>
                <table>
                    <thead>
                        <tr class="bet-winner-title">
                            <td class="px-0 bet-leg text-center">{{ betLeg }}.</td>
                            <td class="betslip-item-header"
                                v-if="betSelection.marketDetailStatus === 2 || betSelection.marketStatusId === 2 || betSelection.betleg.odds === 0 || betSelection.betleg.odds === -1">
                                {{ betSelection.betType }}<span class="detail-status">SUSPENDED</span></td>
                            <td v-else class="betslip-item-header">{{ betSelection.betType }}</td>
                            <td>
                                <template
                                    v-if="betSelection && betSelection.errorMessage && betSelection.errorMessage.indexOf('Failure') !== -1">
                                    <v-btn class="btn-submit-header" color="green" v-on:click="acceptChanges(betSelection)">
                                        Accept changes
                                    </v-btn>
                                </template>
                                <template v-else-if="$store.getters.getAcceptedChanges(betSelection.marketDetailId)">
                                    <v-btn class="btn-submit-header" color="blue" v-on:click="checkLoggedIn(betSelection)"
                                        :disabled="(isBetSubmitting || this.countDown > 0)">
                                        <span v-if="!isBetSubmitting">{{ submitText }}</span>
                                        <v-progress-circular v-if="isBetSubmitting" indeterminate
                                            color="primary"></v-progress-circular>
                                    </v-btn>
                                </template>
                                <template v-else-if="!$store.getters.getAcceptedChanges(betSelection.marketDetailId)">
                                    <v-btn v-if="!betSelection.success"
                                        :disabled="(isBetSubmitting || isAlertClosed || timeout || betSelection.betleg.marketDetailStatus === 2 || betSelection.betleg.stake < 1 || betSelection.betleg.marketStatusId === 2)"
                                        class="btn-submit-header" color="green" v-on:click="checkLoggedIn(betSelection)">
                                        <span v-if="!isBetSubmitting">{{ submitText }}</span>
                                        <v-progress-circular v-if="isBetSubmitting" indeterminate
                                            color="primary"></v-progress-circular>
                                    </v-btn>
                                </template>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="3">
                                <table class="box">
                                    <tr>
                                        <td></td>
                                        <td class="betslip-item"><span><img :src="getSportIconPath(betSelection.sport)"
                                                    class="tournament-title-icon" /></span>{{ betSelection.sport }}</td>
                                        <td class="py-0">
                                            <a @click="removeBet(betSelection)"
                                                :class="{ disabledClick: $store.getters.isSubmitting }">
                                                <i class="material-icons close-bet">delete_outline</i> <span
                                                    class="clear-single-bet">Clear</span>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td class="betslip-item">{{ betSelection.event }} - {{ betSelection.tournament }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td class="betslip-item"><span class="market-selection bold">{{ betSelection.market
                                        }}</span></td>
                                        <td class="oddlock"
                                            v-if="betSelection.betleg.marketDetailStatus === 2 || betSelection.betleg.marketStatusId === 2 || betSelection.betleg.odds === 0 || betSelection.betleg.odds === -1">
                                            <i class="material-icons lock-icon">lock</i>
                                        </td>
                                        <td v-else class="odds">
                                            <!--<div class="oddIncrease-enter-active" v-if="2>0"></div>
                                            <div>{{betSelection.betleg.odds}}</div>
                                            <div class="oddDecrease-enter-active" v-if="2>0"></div>-->
                                            <transition name="oddIncrease">
                                                na
                                                <div @animationend="destroy(betSelection)"
                                                    v-if="getOddsUpdate(betSelection) === true">
                                                </div>
                                            </transition>
                                            {{ betSelection.betleg.odds }}
                                            <transition name="oddDecrease">
                                                <div @animationend="destroy(betSelection)"
                                                    v-if="getOddsUpdate(betSelection) === false">
                                                </div>
                                            </transition>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>

                    </tfoot>
                </table>
                <div style="display:inline-flex; width:100%">
                    <v-flex style="width: 50%" class="border">
                        <v-text-field style="border-top: 1px solid black; border-right: 1px solid black;"
                            @keypress="isNumber($event)" v-model="betSelection.betleg.stake" type=number
                            :hide-details="hideTextFieldHints" min="0" max="99999999" box label="Stake"
                            :disabled="betSelection.betleg.submitting" @input="calculatePayout(betSelection)" required>
                        </v-text-field>

                    </v-flex>
                    <v-flex style="width: 50%" class="border">
                        <v-text-field style="border-top: 1px solid black" :value="calculatePayout(betSelection)"
                            v-model="payoutDefault" :hide-details="hideTextFieldHints" box label="Payout"
                            disabled></v-text-field>
                    </v-flex>
                </div>
            </v-container>
            <template
                v-if="betSelection && betSelection.errorMessage && betSelection.errorMessage.indexOf('Failure') !== -1">
                <!--<v-btn class="btn-submit" color="green" v-on:click="acceptChanges(betSelection)">
                    Accept changes
                </v-btn>-->
            </template>
            <template v-else-if="$store.getters.getAcceptedChanges(betSelection.marketDetailId) && !isBetSubmitting">
                <v-alert :value="betSelection.success" dismissible type="success">
                    Bet Successfully Placed. <br /> Ticket No: {{ betSelection.ticketNumber }}
                </v-alert>
                <v-alert v-model="betSelection.error" dismissible type="error">
                    {{ betSelection.errorMessage }}
                </v-alert>
            </template>
            <template v-else-if="!$store.getters.getAcceptedChanges(betSelection.marketDetailId) && !isBetSubmitting">
                <v-alert :value="betSelection.success" dismissible type="success"
                    @input="dismissBetSuccessMessage(betSelection)">
                    Bet Successfully Placed. <br /> Ticket No: {{ betSelection.ticketNumber }}
                </v-alert>
                <v-alert v-model="betSelection.error" dismissible type="error">
                    {{ betSelection.errorMessage }}
                </v-alert>
            </template>
        </div>
    </div>
</template>

<script>

import Vue from 'vue';
import Utils from '../utils/utils';
import { HubConnection } from "@aspnet/signalr";
import * as CONFIG from "../config"
import BetSlipApi from "../api/BetSlip";
export default {
    name: 'BetSlipItem',
    props: {
        betLeg: Number,
        betSelection: Object,
        betSubmit: Function,
        connection: HubConnection,
        removeBet: Function,
        removeAllBets: Function,
    },
    data() {
        return {
            isAlertClosed: false,
            isBetSubmitting: false,
            clearText: "CLEAR",
            submitText: "SUBMIT BET",
            timeout: false,
            countDown: 10,
            displayCountdown: 10,
            hideTextFieldHints: true,
            payoutDefault: 0,
            submittingNow: false,
            onSubmitShowSpinner: false
        }
    },
    computed: {
        cache: false,
        Autheticated() {
            return this.$store.getters.isAutheticated
        },
        betSelections() {
            let selection = this.$store.getters.betSelection;
            if (selection !== undefined && selection.length > 0) {
                return selection;
            }
            else {
                return '';
            }
        },

    },
    mounted() {
        if (this.connection) {
            this.connection.invoke("Subscribe", this.betSelection.marketDetailId + "betSlip");
            this.connection.on(this.betSelection.marketDetailId + "bs-rcv", (value) => {
                if (value !== null) {
                    this.updateMarketDetail(JSON.parse(value));
                }
            });
        }

    },
    watch: {
        betSelection: function (val, oldBetSelection) {
            if (val !== oldBetSelection) {
                this.payoutDefault = 0;
            }
        },
    },
    methods: {
        checkIfBetHasBeenSubmitted() {
            if (this.$store.getters.isSubmitting) {
                this.onSubmitShowSpinner = true;
            }
            else {
                this.onSubmitShowSpinner = false;
            }
        },
        getSportIconPath(sportName) {
            if (sportName) {
                if (this.betSelection.sport) {
                    const svgName = sportName.replace(/\s/g, '-').toLowerCase();
                    return require(`../assets/img/icons/${svgName}.svg`);
                }
            }
        },
        destroy(betSelection) {
            Vue.set(betSelection, 'css', '')
        },
        getOddsUpdate(betSelection) {
            if (betSelection.css === "oddIncrease") {
                return true;
            }
            else if (betSelection.css === "oddDecrease") {
                return false;
            }
        },
        isNumber: function (evt) {
            var stake = this.betSelection.betleg.stake;
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (stake !== null && stake.length >= 8) {
                evt.preventDefault();
            }
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        updateMarketDetail(updatedMarketDetail) {
            for (let item of this.betSelections) {
                if (item.marketDetailId === updatedMarketDetail.MarketDetailID) {
                    if (item.marketDetailStatus !== updatedMarketDetail.Status) {
                        item.marketDetailStatus = updatedMarketDetail.Status;
                    }
                    if (updatedMarketDetail.MarketStatus !== item.marketStatusId) {
                        item.marketStatusId = updatedMarketDetail.MarketStatus;
                        this.betSelection.betleg.marketDetailStatus = updatedMarketDetail.MarketStatus;
                    }
                    if (updatedMarketDetail.Price > item.betleg.odds) {
                        Vue.set(item, 'css', 'oddIncrease');
                        item.betleg.odds = updatedMarketDetail.Price;

                        if (!item.betleg.submitting) {
                            this.$store.dispatch('setPayoutAmount', item.betleg);
                        }
                    } else if (updatedMarketDetail.Price < item.betleg.odds) {
                        Vue.set(item, 'css', 'oddDecrease');
                        item.betleg.odds = updatedMarketDetail.Price;
                        if (!item.betleg.submitting) {
                            this.$store.dispatch('setPayoutAmount', item.betleg);
                        }
                    }
                    else {
                        Vue.set(item, 'css', '');
                    }
                }
            }
        },
        startCountdown(betSelection) {
            this.isBetSubmitting = true;
            this.isAlertClosed = true;
            let currentStateOfBetSelection = Utils.deepClone(betSelection);
            this.setCountdownTimer(betSelection);
            this.checkIfBetHasBeenSubmitted();
            let priceDrift = this.$store.getters.selectedOddsChange;
            this.$store.dispatch('setSelectionSubmission', { marketDetailId: currentStateOfBetSelection.marketDetailId, success: false, error: false, errorMessage: '', submitting: true });
            this.timeout = true;
            this.$store.dispatch('setIsSubmitting', true);

            let setDisplayTimer = setInterval(() => {
                this.displayCountdown--;
                this.submitText = 'Wait ' + this.displayCountdown;

                if (this.displayCountdown == 0) {
                    clearInterval(setDisplayTimer);
                    this.submitText = 'Submit Bet';
                    this.isBetSubmitting = false;
                    this.$store.dispatch('setIsSubmitting', false);
                }
            }, 1000);

            let setCountDown = setInterval(async () => {
                this.isBetSubmitting = false;
                this.$store.dispatch('setIsSubmitting', true);
                this.countDown--;
                if (this.countDown === 0) {
                    if (priceDrift === 'Accept any odds change') {
                        this.isBetSubmitting = false;
                        clearInterval(setCountDown);
                        this.timeout = false;
                        this.countDown = 10;
                        this.betSubmit(betSelection);
                        this.$store.dispatch('setIsSubmitting', false);
                    }
                    else if (priceDrift === 'Accept higher odds change') {
                        if (currentStateOfBetSelection.betleg.odds > betSelection.betleg.odds) {
                            this.isBetSubmitting = false;
                            clearInterval(setCountDown);
                            clearInterval(setDisplayTimer);
                            this.submitText = 'Submit Bet';
                            this.timeout = false;
                            this.countDown;
                            this.betSubmit(currentStateOfBetSelection);
                            this.$store.dispatch('setIsSubmitting', false);
                        }
                        else {
                            this.isBetSubmitting = false;
                            clearInterval(setCountDown);
                            this.timeout = false;
                            this.countDown;
                            this.betSubmit(betSelection);
                            this.$store.dispatch('setIsSubmitting', false);
                        }
                    }
                    else {
                        this.isBetSubmitting = false;
                        clearInterval(setCountDown);
                        this.timeout = false;
                        this.countDown;
                        this.betSubmit(currentStateOfBetSelection);
                        this.$store.dispatch('setIsSubmitting', false);
                    }
                }
            }, 1000);

            return this.countDown * 1000;
        },
        setCountdownTimer(betSelection) {
            if (betSelection.sport === "Tennis") {
                this.displayCountdown = CONFIG.MATCH_TIMERS.Tennis;
                this.countDown = CONFIG.MATCH_TIMERS.Tennis - CONFIG.MATCH_TIMERS.Difference;
            } else if (betSelection.sport === "RugbyUnion" || betSelection.sport === "RugbyLeague") {
                this.displayCountdown = CONFIG.MATCH_TIMERS.Rugby
                this.countDown = CONFIG.MATCH_TIMERS.Rugby - CONFIG.MATCH_TIMERS.Difference;
            } else if (betSelection.sport === "Cricket" || betSelection.sport === "TestCricket") {
                this.displayCountdown = CONFIG.MATCH_TIMERS.Cricket;
                this.countDown = CONFIG.MATCH_TIMERS.Cricket - CONFIG.MATCH_TIMERS.Difference;
            } else if (betSelection.sport === "Basketball") {
                this.displayCountdown = CONFIG.MATCH_TIMERS.Basketball;
                this.countDown = CONFIG.MATCH_TIMERS.Basketball - CONFIG.MATCH_TIMERS.Difference;
            } else if (betSelection.sport === "Football" || betSelection.sport == "Soccer") {
                this.displayCountdown = CONFIG.MATCH_TIMERS.Soccer;
                this.countDown = CONFIG.MATCH_TIMERS.Soccer - CONFIG.MATCH_TIMERS.Difference;
            } else {
                this.displayCountdown = CONFIG.MATCH_TIMERS.Default;
                this.countDown = CONFIG.MATCH_TIMERS.Default - CONFIG.MATCH_TIMERS.Difference;
            }

        },
        checkLoggedIn(betSelection) {
            this.$store.dispatch('storeCookieAccessToken').then(() => {
                if (this.$store.getters.accessToken !== null) {
                    this.isBetSubmitting = true;

                    this.$store.dispatch('login', {
                        authToken: this.$store.getters.accessToken
                    }).then(async () => {
                        this.startCountdown(betSelection);
                        var resp = await BetSlipApi.submitPreflightBetInfo();
                        if (resp) {
                            this.$store.dispatch('storeSubmitBetRequestId', resp.responseObject);
                        }
                    })
                } else {
                    this.$store.dispatch('setSelectionSubmission', 
                        {
                            error: true,
                            success: false,
                            submitting: false,
                            marketDetailId: betSelection.marketDetailId,
                            errorMessage: 'You need to be logged in to submit a bet'
                        });
                }
            });

        },
        calculatePayout(betSelection) {
            if (!this.betSelection.betleg.stake) {
                this.payoutDefault = 0;
            }
            if (this.betSelection.betleg.stake && this.betSelection.betleg.odds > 0) {
                this.$store.dispatch('setPayoutAmount', this.betSelection.betleg);
                if (betSelection && betSelection.marketDetailId) {
                    this.payoutDefault = this.$store.getters.payoutAmount(betSelection.marketDetailId);
                }
            }
        },
        submitNow(betSelection) {
            this.isBetSubmitting = false;
            let priceDrift = this.$store.getters.selectedOddsChange;
            let currentStateOfBetSelection = Object.assign({}, betSelection);
            //this.$store.dispatch('setselectedOddsChange', 3)
            this.$store.dispatch('setselectedOddsChange', priceDrift)
            this.betSelection.accepted = false;
            this.$store.dispatch('setAcceptedChanges', this.betSelection);
            this.submittingNow = false;
            this.betSubmit(currentStateOfBetSelection);
        },
        acceptChanges(betSelection) {
            this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: false, errorMessage: '', submitting: true });
            this.betSelection.accepted = true;
            this.$store.dispatch('setAcceptedChanges', this.betSelection);
            this.submittingNow = true;
            this.calculatePayout();
        },
        dismissBetSuccessMessage(betSelection) {
            this.isAlertClosed = false;
            this.$store.dispatch('setSelectionSubmission', { marketDetailId: betSelection.marketDetailId, success: false, error: false, errorMessage: '', submitting: false });
        },
    }
}
</script>

<style scoped>
.v-progress-circular {
    margin: 1rem;
}

/*.odd-value{
        padding: 5px 5px 5px 5px;
    }*/
.minStake {
    color: #929292 !important;
    font-size: 12px;
    position: relative;
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
    font-weight: normal;
    margin-top: -12px;
    padding-bottom: 10px;
}

.market-selection {
    color: #F4EA22;
}

.oddlock {
    background-color: #272727 !important;
}

.tournament-title-icon {
    width: 16px;
    margin-right: 5px;
    vertical-align: top;
    padding-top: 2px;
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
    .odds {
        padding-right: 10px !important;
        background-color: #191927;
    }

    .oddIncrease-enter-active {
        right: 0px !important;
        bottom: 0px !important;
        top: 10px !important;
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent;
    }

    .oddDecrease-enter-active {
        right: 0px !important;
        bottom: 0px !important;
        top: 10px !important;
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent;
    }
}

@supports (-ms-ime-align:auto) {
    .odds {
        padding-right: 10px;
        background-color: #191927;
    }

    .oddIncrease-enter-active {
        right: 0px !important;
        bottom: 0px !important;
        transform: translateY(-8px);
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent;
    }

    .oddDecrease-enter-active {
        right: 0px !important;
        bottom: 0px !important;
        transform: translateY(-8px) rotate(90deg) !important;
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent;
    }
}

.border {
    border: 0px solid #fff !important;
}

@media (min-width:989px) {
    .border:last-child {
        border-left: none !important;
    }
}

.btn-submit {
    width: 100%;
    margin: 16px 0px;
    display: inline-block;
    font-weight: 600;
}

.btn-submit-header {
    width: 100%;
    margin-right: 16px;
    /*margin: 16px 0px;*/
    line-height: 4px;
    /*display: inline-block;*/
    font-weight: 400;
    font-size: 10px;
    color: black;
}

.material-icons {
    color: red;
    font-weight: bolder;
    position: relative;
    font-size: 18px;
}

.disabledClick {
    pointer-events: none;
    cursor: default;
}

.disabledClick .material-icons {
    color: grey;
    font-weight: bolder;
}

.lock-icon {
    color: white;
    font-weight: bolder;
}

.detail-status {
    background: #616161;
    color: #fff;
    display: inline-block;
    border-radius: 3px;
    white-space: pre-wrap;
    font-size: 85%;
    font-weight: 900;
    line-height: 1.5;
    font-family: monospace, monospace;
    padding-left: 4px;
    padding-right: 4px;
    top: -1px;
    position: relative;
    margin-left: 10px;
}

.odds {
    color: gold;
    font-size: 12px;
    font-weight: 300;
    text-align: right;
}

.oddIncrease-enter-active {
    animation: increase 6s;
    bottom: 0px;
    right: 14px !important;
}

@keyframes increase {
    100% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent #2ad100 transparent transparent;
    }

    80% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent transparent transparent transparent;
    }

    60% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent #2ad100 transparent transparent;
    }

    40% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent transparent transparent transparent;
    }

    20% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent #2ad100 transparent transparent;
    }

    0% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent transparent transparent transparent;
    }
}

.oddDecrease-enter-active {
    right: 5px;
    /*transform: rotate(90deg);*/
    animation: decrease 6s;
}

@keyframes decrease {
    100% {
        border-style: solid;
        border-width: 10px 10px 0px 0px;
        border-color: transparent #f50000 transparent transparent;
    }

    80% {
        border-style: solid;
        border-width: 10px 10px 0px 0px;
        border-color: transparent transparent transparent transparent;
    }

    60% {
        border-style: solid;
        border-width: 10px 10px 0px 0px;
        border-color: transparent #f50000 transparent transparent;
    }

    40% {
        border-style: solid;
        border-width: 10px 10px 0px 0px;
        border-color: transparent transparent transparent transparent;
    }

    20% {
        border-style: solid;
        border-width: 10px 10px 0px 0px;
        border-color: transparent #f50000 transparent transparent;
    }

    0% {
        border-style: solid;
        border-width: 10px 10px 0px 0px;
        border-color: transparent transparent transparent transparent;
    }
}

.betslip-item {
    color: #efefef;
    font-size: 13px;
    font-weight: normal;
    line-height: 23px;
}

.box {
    padding: 8px 10px;
    border: 0px solid #fff;
    border-radius: 0px;
    background-color: #272727;
    margin-top: 5px;
}

.betslip-item-header {
    color: white;
    font-size: 11px;
    line-height: 17px;
    padding-left: 10px;
    text-align: left;
    padding-bottom: 1px;
    text-transform: uppercase;
    width: 100%;
}

.bet-slip-item-container table {
    width: 100%;
    border-spacing: 0;
}

.bet-slip-item-container table thead {
    width: 100%;
}

.bet-slip-item-container table thead td:nth-child(3) {
    padding-right: 15px;
}

.bet-slip-item-container .flex.border.xs12.md6 {
    -ms-flex-preferred-size: 100% !important;
    flex-basis: 100% !important;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 100% !important;
}

.bet-slip-item-container tfoot td.odds {
    position: relative;
    font-size: 15px;
    background-color: #191927;
    color: #f4ea22;
    font-weight: 700;
    padding-right: 10px;
    min-width: 50px;
}

.bet-slip-item-container button.btn-submit {
    height: 30px;
    font-size: 12px;
}

.betslip-item-uppercase {
    color: #fff;
    font-size: 11px;
    padding: 12px 0px;
    text-transform: capitalize;
    font-size: 15px;
    font-weight: 500;
    padding-left: 10px;
    background-color: #191927;
}

.bet-slip-item-container .odds {
    /*border: 1px solid #F4C822;
        border-radius: 5px;
        padding: 3px 3px 3px 3px;
        text-align: center;*/
    /*padding: 3px 3px 3px 3px;
        border-radius: 5px;
        background-color: #F4EA22;*/
    color: #F4EA22;
    font-weight: 700;
}

.close-bet {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    color: #96999b !important;
    right: 2px !important;
    font-size: 16px;
    display: inline;
    /*top: 48px;*/
    font-weight: 500;
}

.clear-single-bet {
    font-size: 12px;
    font-weight: 300;
    font-size: 14px;
    font-weight: 500;
    float: none;
    top: -2px;
    position: relative;
    color: #96999b;
    margin-right: 0px;
}

@media(max-width:320px) {
    .box {
        padding: 5px 5px 5px 5px !important;
    }

    .betslip-item {
        font-size: 11px;
    }

    .betslip-item-header {
        font-size: 14px;
        padding-bottom: 0px;
    }

    .betslip-item-uppercase {
        font-size: 14px
    }

    .odds {
        font-size: 12px;
    }
}

.bet-leg {
    font-size: 15px;
    font-weight: normal;
    padding-left: 10px !important;
    padding-top: 4px;
}

.text-center {
    text-align: center;
}

.section {
    background-color: #272727;
    padding: 0px 0px 0px 0px;
}

.v-label {
    font-size: 11px;
}
</style>